import React from "react";
import {
    RadioGroup,
    Radio,
    FormControlLabel,
    TextField,
    Select,
    MenuItem,
    Typography,
    Checkbox,
    Button,
} from "@material-ui/core";
import { ErrorMessage } from "formik";
import dateFnsFormat from "date-fns/format";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

const OtherDetails = (props) => {

    return(
        <div className="form-section-root">
            <div className="form-row form-header-row">
                <div className="form-group">
                    <Typography className="normal-text">
                        <b>OTHER DETAILS</b>
                    </Typography>
                </div>
            </div>
            <div className="form-row">
                <div className="form-group sub-header">
                    <Typography><b>Income Details</b> <Imp/></Typography>
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col-100 radio-div">
                    <label>Source of Income</label>
                    <div className="check-box-group flex-row gap-10">
                        <FormControlLabel
                            name="otherDetails.sourceOfIncome.salary"
                            value={props.values.otherDetails.sourceOfIncome.salary}
                            label="Salary"
                            control={<Checkbox color="secondary" />}
                            onChange={(e) => {
                                props.setFieldValue("otherDetails.sourceOfIncome.salary",e.target.checked ? 'Y' : 'N');
                            }}
                        />
                        <FormControlLabel
                            name="otherDetails.sourceOfIncome.otherSource"
                            value={props.values.otherDetails.sourceOfIncome.otherSource}
                            label="Other Source"
                            control={<Checkbox color="secondary" />}
                            onChange={(e) => {
                                props.setFieldValue("otherDetails.sourceOfIncome.otherSource",e.target.checked ? '1' : '0');
                            }}
                        />
                        <FormControlLabel
                            name="otherDetails.sourceOfIncome.businessProf"
                            value={props.values.otherDetails.sourceOfIncome.businessProf}
                            label="Business"
                            control={<Checkbox color="secondary" />}
                            onChange={(e) => {
                                props.setFieldValue("otherDetails.sourceOfIncome.businessProf",e.target.checked ? 'd' : '');
                            }}
                            // disabled={props.values.otherDetails.sourceOfIncome.noIncome == '1'}
                        />
                        <FormControlLabel
                            name="otherDetails.sourceOfIncome.noIncome"
                            value={props.values.otherDetails.sourceOfIncome.noIncome}
                            label="No Income"
                            control={<Checkbox color="secondary" />}
                            onChange={(e) => {
                                props.setFieldValue("otherDetails.sourceOfIncome.noIncome",e.target.checked ? 'H' : '');
                            }}
                            // disabled={
                            //     props.values.otherDetails.sourceOfIncome.salary == 'Y' ||
                            //     props.values.otherDetails.sourceOfIncome.otherSource == 'C' ||
                            //     props.values.otherDetails.sourceOfIncome.businessProf == 'd' ||
                            //     props.values.otherDetails.sourceOfIncome.housePro == 'B' ||
                            //     props.values.otherDetails.sourceOfIncome.capitalGains == 'D'
                            // }
                        />
                        <FormControlLabel
                            name="otherDetails.sourceOfIncome.housePro"
                            value={props.values.otherDetails.sourceOfIncome.housePro}
                            label="House/Property"
                            control={<Checkbox color="secondary" />}
                            onChange={(e) => {
                                props.setFieldValue("otherDetails.sourceOfIncome.housePro",e.target.checked ? 'B' : '');
                            }}
                            // disabled={props.values.otherDetails.sourceOfIncome.noIncome == '1'}
                        />
                        <FormControlLabel
                            name="otherDetails.sourceOfIncome.capitalGains"
                            value={props.values.otherDetails.sourceOfIncome.capitalGains}
                            label="Capital Gains"
                            control={<Checkbox color="secondary" />}
                            onChange={(e) => {
                                props.setFieldValue("otherDetails.sourceOfIncome.capitalGains",e.target.checked ? 'D' : '');
                            }}
                            // disabled={props.values.otherDetails.sourceOfIncome.noIncome == '1'}
                        />
                    </div>
                </div>
            </div>
            {props.values.otherDetails.sourceOfIncome.businessProf == "d" && 
            <div className="form-row">
                <div className="form-group sel-inp col-25">
                    <label>Select Business/Profession <Imp/></label>
                        <Select
                            value={props.values.otherDetails.sourceOfIncome.businessPrfCode}
                            name="otherDetails.sourceOfIncome.businessPrfCode"
                            fullWidth
                            variant="outlined"
                            color="secondary"
                            onChange={e => {
                                props.setFieldValue("otherDetails.sourceOfIncome.businessPrfCode", e.target.value);
                            }}
                        >
                            {BusinessPrfCodes && BusinessPrfCodes.map((val, ind) =>
                                <MenuItem value={val.value} key={ind}>{val.label}</MenuItem>
                            )}
                        </Select>
                </div>
            </div>}
            <div className="form-row flex-row gap-10">
                <div className="form-group radio-div col-25">
                    <label>Address for communication <Imp/></label>
                    <RadioGroup className="form-radio-group"
                        value={props.values.otherDetails.addrForCommunication}
                        name="otherDetails.addrForCommunication"
                        onChange={e => { props.setFieldValue("otherDetails.addrForCommunication", e.target.value) }}
                    >
                        <FormControlLabel
                            value="R"
                            label="Residence"
                            control={<Radio color="secondary" />}
                            disabled={props.values.applicantDto.applnMode == "E"}
                        />
                        <FormControlLabel
                            value="O"
                            label="Office"
                            control={<Radio color="secondary" />}
                            disabled={props.values.applicantDto.applnMode == "K" || props.values.applicantDto.applnMode == ""}
                        />
                    </RadioGroup>
                </div>
                {props.values.applicantDto.applnMode === "E" &&
                <div className="form-group radio-div col-25">
                    <label>Representative Assessee <Imp/></label>
                    <RadioGroup className="form-radio-group"
                        value={props.values.otherDetails.raValue}
                        name="otherDetails.raValue"
                        onChange={e => { props.setFieldValue("otherDetails.raValue", e.target.value) }}
                    >
                        <FormControlLabel
                            value="Y"
                            label="Yes"
                            control={<Radio color="secondary" />}
                        />
                        <FormControlLabel
                            value="N"
                            label="No"
                            control={<Radio color="secondary" />}
                        />
                    </RadioGroup>
                </div>}
            </div>
            {(props.values.otherDetails.addrForCommunication == "O" || 
            props.values.otherDetails.sourceOfIncome.salary == "1" ||
            props.values.otherDetails.sourceOfIncome.businessProf == "1") && 
            <>
                <div className="form-row">
                    <div className="form-group sub-header">
                        <Typography><b>Ofice Address</b> <Imp/></Typography>
                    </div>
                </div>
                <div className="form-row flex-row gap-10">
                    <div className="form-group text-inp col-25">
                        <label>Flat No. <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.officeAddress.flatNo}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.officeAddress.flatNo"
                            onChange={e => {
                                props.setFieldValue("otherDetails.officeAddress.flatNo", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>Name of Premises <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.officeAddress.nameOfPremises}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.officeAddress.nameOfPremises"
                            onChange={e => {
                                props.setFieldValue("otherDetails.officeAddress.nameOfPremises", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>Road</label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.officeAddress.road}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.officeAddress.road"
                            onChange={e => {
                                props.setFieldValue("otherDetails.officeAddress.road", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>Area <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.officeAddress.area}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.officeAddress.area"
                            onChange={e => {
                                props.setFieldValue("otherDetails.officeAddress.area", e.target.value);
                            }}
                        />
                    </div>
                </div>
                <div className="form-row flex-row gap-10">
                    <div className="form-group text-inp col-25">
                        <label>Town <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.officeAddress.town}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.officeAddress.town"
                            onChange={e => {
                                props.setFieldValue("otherDetails.officeAddress.town", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>Country <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.officeAddress.countryName}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.officeAddress.countryName"
                            onChange={e => {
                                props.setFieldValue("otherDetails.officeAddress.countryName", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>State <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.officeAddress.state}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.officeAddress.state"
                            onChange={e => {
                                props.setFieldValue("otherDetails.officeAddress.state", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>PIN Code <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.officeAddress.pinCode}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.officeAddress.pinCode"
                            onChange={e => {
                                props.setFieldValue("otherDetails.officeAddress.pinCode", e.target.value);
                            }}
                        />
                    </div>
                </div>
                <div className="form-row flex-row gap-10">
                    <div className="form-group text-inp col-25">
                        <label>ZIP Code </label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.officeAddress.zipCode}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.officeAddress.zipCode"
                            onChange={e => {
                                props.setFieldValue("otherDetails.officeAddress.zipCode", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>Office Name <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.officeAddress.officeName}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.officeAddress.officeName"
                            onChange={e => {
                                props.setFieldValue("otherDetails.officeAddress.officeName", e.target.value);
                            }}
                        />
                    </div>
                </div>
            </>}
            {props.values.otherDetails.raValue == "Y" && 
            <>
                <div className="form-row">
                    <div className="form-group sub-header">
                        <Typography><b>Representative Assessee Details</b> <Imp/></Typography>
                    </div>
                </div>
                <div className="form-row flex-row gap-10">
                    <div className="form-group select-inp col-25">
                        <label>R.A. Title <Imp/></label>
                        <Select
                            value={props.values.otherDetails.raTitle}
                            name="otherDetails.raTitle"
                            fullWidth
                            variant="outlined"
                            color="secondary"
                            onChange={e => {
                                props.setFieldValue("otherDetails.raTitle", e.target.value);
                            }}
                        >
                            <MenuItem value={1}>Shri</MenuItem>
                            <MenuItem value={2}>Smt.</MenuItem>
                            <MenuItem value={3}>Kumari</MenuItem>
                        </Select>
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>R.A. First Name <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.raFirstName}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.raFirstName"
                            onChange={e => {
                                props.setFieldValue("otherDetails.raFirstName", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>R.A. Middle Name <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.raMiddleName}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.raMiddleName"
                            onChange={e => {
                                props.setFieldValue("otherDetails.raMiddleName", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>R.A. Last Name <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.raLastName}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.raLastName"
                            onChange={e => {
                                props.setFieldValue("otherDetails.raLastName", e.target.value);
                            }}
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group sub-header">
                        <Typography><b>Representative Assessee Address</b> <Imp/></Typography>
                    </div>
                </div>
                <div className="form-row flex-row gap-10">
                    <div className="form-group text-inp col-25">
                        <label>R.A. Flat No. <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.raAddress.raFlatNo}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.raAddress.raFlatNo"
                            onChange={e => {
                                props.setFieldValue("otherDetails.raAddress.raFlatNo", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>R.A. Name of Premises <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.raAddress.raNameOfPremises}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.raAddress.raNameOfPremises"
                            onChange={e => {
                                props.setFieldValue("otherDetails.raAddress.raNameOfPremises", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>R.A. Road</label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.raAddress.raRoad}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.raAddress.raRoad"
                            onChange={e => {
                                props.setFieldValue("otherDetails.raAddress.raRoad", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>R.A. Area <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.raAddress.raArea}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.raAddress.raArea"
                            onChange={e => {
                                props.setFieldValue("otherDetails.raAddress.raArea", e.target.value);
                            }}
                        />
                    </div>
                </div>
                <div className="form-row flex-row gap-10">
                    <div className="form-group text-inp col-25">
                        <label>R.A. Town <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.raAddress.raTown}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.raAddress.raTown"
                            onChange={e => {
                                props.setFieldValue("otherDetails.raAddress.raTown", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>R.A. Country <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.raAddress.raCountryName}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.raAddress.raCountryName"
                            onChange={e => {
                                props.setFieldValue("otherDetails.raAddress.raCountryName", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>R.A. State <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.raAddress.raState}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.raAddress.raState"
                            onChange={e => {
                                props.setFieldValue("otherDetails.raAddress.raState", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>R.A. PIN Code <Imp/></label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.raAddress.raPinCode}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.raAddress.raPinCode"
                            onChange={e => {
                                props.setFieldValue("otherDetails.raAddress.raPinCode", e.target.value);
                            }}
                        />
                    </div>
                </div>
                <div className="form-row flex-row gap-10">
                    <div className="form-group text-inp col-25">
                        <label>R.A. ZIP Code </label>
                        <TextField
                            fullWidth
                            value={props.values.otherDetails.raAddress.raZipCode}
                            color="secondary"
                            variant="outlined"
                            name="otherDetails.raAddress.raZipCode"
                            onChange={e => {
                                props.setFieldValue("otherDetails.raAddress.raZipCode", e.target.value);
                            }}
                        />
                    </div>
                </div>
            </>}
            <div className="form-row flex-row gap-10">
                <div className="form-group text-inp col-25">
                    <label>ISD Code <Imp/></label>
                    <TextField
                        fullWidth
                        value={props.values.otherDetails.isdCode}
                        color="secondary"
                        variant="outlined"
                        name="otherDetails.isdCode"
                        onChange={e => {
                            props.setFieldValue("otherDetails.isdCode", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>STD Code</label>
                    <TextField
                        fullWidth
                        value={props.values.otherDetails.stdCode}
                        color="secondary"
                        variant="outlined"
                        name="otherDetails.stdCode"
                        onChange={e => {
                            props.setFieldValue("otherDetails.stdCode", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Telephone/Mobile <Imp/></label>
                    <TextField
                        fullWidth
                        value={props.values.otherDetails.telOrMobNo}
                        color="secondary"
                        variant="outlined"
                        name="otherDetails.telOrMobNo"
                        onChange={e => {
                            props.setFieldValue("otherDetails.telOrMobNo", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Email ID</label>
                    <TextField
                        fullWidth
                        value={props.values.otherDetails.emailId}
                        color="secondary"
                        variant="outlined"
                        name="otherDetails.emailId"
                        onChange={e => {
                            props.setFieldValue("otherDetails.emailId", e.target.value);
                        }}
                    />
                </div>
            </div>
            {props.values.applicantDto.applnMode !== "" && props.values.applicantDto.applnMode !== "K" &&
            <>
            <div className="form-row">
                <div className="form-group sub-header">
                    <Typography><b>Residence Address</b> <Imp /></Typography>
                </div>
            </div>
            <div className="form-row flex-row gap-10">
                <div className="form-group text-inp col-25">
                    <label>Flat No. <Imp /></label>
                    <TextField
                        fullWidth
                        value={props.values.otherDetails.residenceAddress.rflatNo}
                        color="secondary"
                        variant="outlined"
                        name="otherDetails.residenceAddress.rflatNo"
                        onChange={e => {
                            props.setFieldValue("otherDetails.residenceAddress.rflatNo", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Name of Premises <Imp /></label>
                    <TextField
                        fullWidth
                        value={props.values.otherDetails.residenceAddress.rnameOfPremises}
                        color="secondary"
                        variant="outlined"
                        name="otherDetails.residenceAddress.rnameOfPremises"
                        onChange={e => {
                            props.setFieldValue("otherDetails.residenceAddress.rnameOfPremises", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Road</label>
                    <TextField
                        fullWidth
                        value={props.values.otherDetails.residenceAddress.rroad}
                        color="secondary"
                        variant="outlined"
                        name="otherDetails.residenceAddress.rroad"
                        onChange={e => {
                            props.setFieldValue("otherDetails.residenceAddress.rroad", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Area <Imp /></label>
                    <TextField
                        fullWidth
                        value={props.values.otherDetails.residenceAddress.rarea}
                        color="secondary"
                        variant="outlined"
                        name="otherDetails.residenceAddress.rarea"
                        onChange={e => {
                            props.setFieldValue("otherDetails.residenceAddress.rarea", e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className="form-row flex-row gap-10">
                <div className="form-group text-inp col-25">
                    <label>Town <Imp /></label>
                    <TextField
                        fullWidth
                        value={props.values.otherDetails.residenceAddress.rtown}
                        color="secondary"
                        variant="outlined"
                        name="otherDetails.residenceAddress.rtown"
                        onChange={e => {
                            props.setFieldValue("otherDetails.residenceAddress.rtown", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Country <Imp /></label>
                    <TextField
                        fullWidth
                        value={props.values.otherDetails.residenceAddress.rcountryName}
                        color="secondary"
                        variant="outlined"
                        name="otherDetails.residenceAddress.rcountryName"
                        onChange={e => {
                            props.setFieldValue("otherDetails.residenceAddress.rcountryName", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>State <Imp /></label>
                    <TextField
                        fullWidth
                        value={props.values.otherDetails.residenceAddress.rstate}
                        color="secondary"
                        variant="outlined"
                        name="otherDetails.residenceAddress.rstate"
                        onChange={e => {
                            props.setFieldValue("otherDetails.residenceAddress.rstate", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>PIN Code <Imp /></label>
                    <TextField
                        fullWidth
                        value={props.values.otherDetails.residenceAddress.rpinCode}
                        color="secondary"
                        variant="outlined"
                        name="otherDetails.residenceAddress.rpinCode"
                        onChange={e => {
                            props.setFieldValue("otherDetails.residenceAddress.rpinCode", e.target.value);
                        }}
                    />
                </div>
            </div>
            <div className="form-row flex-row gap-10">
                <div className="form-group text-inp col-25">
                    <label>ZIP Code </label>
                    <TextField
                        fullWidth
                        value={props.values.otherDetails.residenceAddress.rzipCode}
                        color="secondary"
                        variant="outlined"
                        name="otherDetails.residenceAddress.rzipCode"
                        onChange={e => {
                            props.setFieldValue("otherDetails.residenceAddress.rzipCode", e.target.value);
                        }}
                    />
                </div>
            </div>
            </>}
            {/* <div className="form-row">
                <div className="form-group sub-header">
                    <Typography><b>AO Details</b> <Imp /></Typography>
                </div>
            </div>
            <div className="form-row flex-row gap-10">
                <div className="form-group text-inp col-25">
                    <label>Area Code <Imp /></label>
                    <TextField
                        fullWidth
                        value={props.values.aoCode.areaCode}
                        color="secondary"
                        variant="outlined"
                        name="aoCode.areaCode"
                        onChange={e => {
                            props.setFieldValue("aoCode.areaCode", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>AO Type <Imp /></label>
                    <TextField
                        fullWidth
                        value={props.values.aoCode.aoType}
                        color="secondary"
                        variant="outlined"
                        name="aoCode.aoType"
                        onChange={e => {
                            props.setFieldValue("aoCode.aoType", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Range Code <Imp /></label>
                    <TextField
                        fullWidth
                        value={props.values.aoCode.rangeCode}
                        color="secondary"
                        variant="outlined"
                        name="aoCode.rangeCode"
                        onChange={e => {
                            props.setFieldValue("aoCode.rangeCode", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>AO No. <Imp /></label>
                    <TextField
                        fullWidth
                        value={props.values.aoCode.aoNo}
                        color="secondary"
                        variant="outlined"
                        name="aoCode.aoNo"
                        onChange={e => {
                            props.setFieldValue("aoCode.aoNo", e.target.value);
                        }}
                    />
                </div>
            </div> */}
            <div className="form-row form-header-row">
                <div className="form-group">
                    <Typography className="normal-text">
                        <b>Place & Date</b>
                    </Typography>
                </div>
            </div>
            <div className="form-row flex-row gap-10">
                <div className="form-group text-inp col-25">
                    <label>Place <Imp /></label>
                    <TextField
                        fullWidth
                        value={props.values.otherDetails.place}
                        color="secondary"
                        variant="outlined"
                        name="otherDetails.place"
                        onChange={e => {
                            props.setFieldValue("otherDetails.place", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Date <Imp /></label>
                    <MuiPickersUtilsProvider
                        utils={DateFnsUtils}
                    >
                        <KeyboardDatePicker
                            name={`otherDetails.dateDisplay`}
                            inputVariant="outlined"
                            disableToolbar
                            // disablePast
                            // disableFuture
                            autoOk={true}
                            value={props.values.otherDetails.dateDisplay}
                            onChange={(date) => {
                                props.setFieldValue(`otherDetails.date`, dateFnsFormat(date, "dd/MM/yyyy"));
                                props.setFieldValue(`otherDetails.dateDisplay`, date);
                            }}
                            format="dd MMM yyyy"
                            KeyboardButtonProps={{
                                "aria-label": "change date",
                            }}
                            style={{ width: "100%" }}
                            disabled
                        />

                    </MuiPickersUtilsProvider>
                    {/* <CustomDatePicker
                        showDisabledMonthNavigation
                        minDate={new Date()}
                        name={`otherDetails.dateDisplay`}
                        className="form-date-picker"
                        customInput={
                            <TextField
                                variant="outlined"
                                color="secondary"
                                fullWidth
                            />
                        }
                        selected={props.values.otherDetails.dateDisplay}
                        onChange={(newDate) => {
                            props.setFieldValue(`otherDetails.date`, dateFnsFormat(newDate, "dd/MM/yyyy"));
                            props.setFieldValue(`otherDetails.dateDisplay`, newDate);
                        }}
                        dateFormat="dd MMM yyyy"
                        monthsShown={2}
                    /> */}
                </div>
                <div className="form-group col-50 action-group ta-right pt-30">
                    <Button
                        type="submit"
                    >
                        Submit
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default OtherDetails;

const Imp = () => <span className="imp">*</span>;

const BusinessPrfCodes = [
    {label: "Select", value: ""},
    {label: "Medical Profession and Business", value: "01"},
    {label: "Engineering", value: "02"},
    {label: "Architecture", value: "03"},
    {label: "Chartered Accountant/ Accountancy", value: "04"},
    {label: "Interior Decoration", value: "05"},
    {label: "Technical Consultancy", value: "06"},
    {label: "Company Secretary", value: "07"},
    {label: "Legal Practitioner and Solicitors", value: "08"},
    {label: "Government Contractors", value: "09"},
    {label: "Insurance Agency", value: "10"},
    {label: "Films, TV and such other entertainment", value: "11"},
    {label: "Information Technology", value: "12"},
    {label: "Builders and Developers", value: "13"},
    {label: "Members of Stock Exchange and Share Brokers and Sub-brokers", value: "14"},
    {label: "Performing Arts and Yatra", value: "15"},
    {label: "Operations of Ship, Hovercraft, Aircrafts or Helicopters", value: "16"},
    {label: "Plying Taxis, Lorries, Trucks, Buses or other Commercial Vehicles", value: "17"},
    {label: "Ownership of Horses or Jockeys+G1:H24", value: "18"},
    {label: "Cinema Halls and Other Theaters", value: "19"},
    {label: "Others", value: "20"}
];
